import { RouteType } from 'types/RouteType';
// import UserPermissionsIcon from '@mui/icons-material/GroupAdd';

const permissionsRoute: RouteType[] = [
  {
    name: 'Permissions',
    path: '/permissions/user',
    layout: '/app',
    viewportCard: {
      header: {
        title: 'Permissions',
        // component: () => import('./Permissions.Header'),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // component: () => import('./Permissions.Body'),
        gridContainer: {
          namespace: 'PermissionsDataGrid',
          storeName: 'userPermissionManagementStore',
          customEntity: 'userList',
          // fixedRowCount: 2,
          columnHeaders: [
            {
              width: 280,
              key: 'email',
              title: 'User',
            },
            {
              width: 200,
              key: 'firstName',
              title: 'First Name',
            },
            {
              width: 200,
              key: 'lastName',
              title: 'Last Name',
            },
            {
              width: 250,
              key: 'department',
              title: 'Department',
            },
            {
              width: 250,
              key: 'team',
              title: 'Team',
            },
          ],
          defaultSort: {
            sortBy: ['email'],
            sortDirection: { email: 'ASC' },
          },
          onRowClick: () => console.log('Clicked'),
          // onRowClick: ({ controlUUID }) =>
          // openDialog({
          //   dialogName: 'QR Code',
          //   dialogContext: controlUUID
          // })
        },
      },
    },
    group: 'Administration',
  requiresAuth: false, // Assuming requiresAuth should default to false if not specified
    requiresPermission: false,
    requiresAdmin: true,
    channels: ['user', 'departments'],
    // beforeEnter: async ({ rootStore }) => {
    //   const {
    //     userStore: { find: findUsers },
    //   } = rootStore;
    //   findUsers();
    //   return true;
    // },
  },
  // {
  //   name: 'Permissions',
  //   path: '/permissions/user',
  //   layout: '/app',
  //   viewportCard: {
  //     header: {
  //       title: 'Permissions',
  //       component: () => import('./User/UserPermissions.Header'),
  //     },
  //     body: {
  //       component: () => import('./User/UserPermissions.Body'),
  //     },
  //   },
  //   requiresAuth: false, // Assuming requiresAuth should default to false if not specified
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ['user', 'departments'],
  //   beforeEnter: async ({ rootStore }) => {
  //     const {
  //       userStore: { find: findUsers },
  //     } = rootStore;
  //     findUsers();
  //   },
  // },
  // {
  //   name: "User Permission",
  //   path: "/permissions/user/:userId",
  //   layout: "/app",
  //   viewportCard: {
  //     header: {
  //       title: "User Permission",
  //       component: () =>
  //         import(
  //           "./User/UserPermissionManagement/UserPermissionManagement.Header"
  //         ),
  //     },
  //     body: {
  //       component: () =>
  //         import(
  //           "./User/UserPermissionManagement/UserPermissionManagement.Body"
  //         ),
  //     },
  //   },
  //   subRoutes: ["Permissions"],
  //   parentRoute: "Permissions",
  //   defaultParams: { userId: "" },
  //   requiresAuth: false,
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ["user/:userId", "v2/user-permissions/:userId"],
  //   beforeEnter: async ({ rootStore, params }) => {
  //     const {
  //       userStore: { get: getUser },
  //       userPermissionsStore: { find: findUserPermissions },
  //     } = rootStore;
  //     const { userId } = params;
  //     getUser(userId);

  //     findUserPermissions({
  //       query: {
  //         userId: `${userId}`,
  //         appName: rootStore.appName,
  //         $limit: 1000,
  //       },
  //     });
  //   },
  //   onParamsChange: async ({ rootStore }) => {
  //     rootStore.routerStore.triggerEnterSideEffects();
  //   },
  // },
  // {
  //   name: "Department Permissions",
  //   path: "/permissions/department",
  //   layout: "/app",
  //   viewportCard: {
  //     header: {
  //       title: "Department Permissions",
  //       component: () => import("./Department/DepartmentPermissions.Header"),
  //     },
  //     body: {
  //       component: () => import("./Department/DepartmentPermissions.Body"),
  //     },
  //   },
  //   parentRoute: "Permissions",
  //   requiresAuth: false,
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ["user", "departments"],
  //   beforeEnter: async ({ rootStore }) => {
  //     const {
  //       userStore: { find: findUsers },
  //     } = rootStore;
  //     findUsers();
  //   },
  // },
  // {
  //   name: "Department Permission Management",
  //   path: "/permissions/department/:department",
  //   layout: "/app",
  //   viewportCard: {
  //     header: {
  //       title: "Department Permission Management",
  //       component: () =>
  //         import(
  //           "./Department/DepartmentPermissionManagement/DepartmentPermissionManagement.Header"
  //         ),
  //     },
  //     body: {
  //       component: () =>
  //         import(
  //           "./Department/DepartmentPermissionManagement/DepartmentPermissionManagement.Body"
  //         ),
  //     },
  //   },
  //   subRoutes: ["Permissions"],
  //   parentRoute: "Permissions",
  //   defaultParams: { department: "" },
  //   requiresAuth: false,
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ["user/:department", "departments", "department-permissions"],
  //   beforeEnter: async ({ rootStore, params }) => {
  //     const {
  //       departmentPermissionsStore: { find: findDepartmentPermissions },
  //     } = rootStore;
  //     let { department } = params;
  //     if (department === "DandE") {
  //       department = "D&E";
  //     }

  //     findDepartmentPermissions({
  //       query: {
  //         $limit: 2000,
  //         departmentName: department,
  //         appName: rootStore.appName,
  //       },
  //     });
  //   },
  //   onParamsChange: async ({ rootStore }) => {
  //     rootStore.routerStore.triggerEnterSideEffects();
  //   },
  // },
  // {
  //   name: "Route Permissions",
  //   path: "/permissions/routes",
  //   layout: "/app",
  //   viewportCard: {
  //     header: {
  //       title: "Route Permissions",
  //       component: () => import("./Route/RoutePermissions.Header"),
  //     },
  //     body: {
  //       component: () => import("./Route/RoutePermissions.Body"),
  //     },
  //   },
  //   parentRoute: "Permissions",
  //   requiresAuth: false,
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ["user"],
  //   beforeEnter: async ({ rootStore }) => {
  //     const {
  //       userStore: { find: findUsers },
  //     } = rootStore;
  //     findUsers();
  //   },
  //   onParamsChange: async ({ rootStore }) => {
  //     rootStore.routerStore.triggerEnterSideEffects();
  //   },
  // },
  // {
  //   name: "Route Permission Management",
  //   path: "/permissions/routes/:route",
  //   layout: "/app",
  //   viewportCard: {
  //     header: {
  //       title: "Route Permission Management",
  //       component: () => import("./Route/RoutePermissionManagement.Header"), // Added Header component import
  //     },
  //     body: {
  //       component: () => import("./Route/RoutePermissionManagement.Body"), // Added Body component import
  //     },
  //   },
  //   subRoutes: ["Permissions"],
  //   parentRoute: "Permissions",
  //   defaultParams: { route: "" },
  //   requiresAuth: false,
  //   requiresPermission: false,
  //   requiresAdmin: true,
  //   channels: ["v2/user-permissions", "user"],
  //   beforeEnter: async ({ rootStore, params }) => {
  //     const {
  //       userStore: { find: findUsers },
  //       userPermissionsStore: { find: findUserPermissions },
  //       userPermissionManagementStore: { routesList },
  //       authStore: { currentUser },
  //     } = rootStore;
  //     const { route } = params;
  //     const foundRoute = routesList.find((r) => r.routeNavName === route);
  //     if (foundRoute) {
  //       if (foundRoute.permissionPath) {
  //         findUserPermissions({
  //           query: {
  //             location: foundRoute.permissionPath,
  //             appName: rootStore.appName,
  //           },
  //         });
  //       } else {
  //         findUserPermissions({
  //           query: {
  //             location: foundRoute.fullPath,
  //             appName: rootStore.appName,
  //           },
  //         });
  //       }
  //     } else {
  //       findUserPermissions({
  //         query: { appName: rootStore.appName },
  //       });
  //     }

  //     if (currentUser.department === "Developer") {
  //       findUsers();
  //     } else {
  //       findUsers({ query: { department: currentUser.department } });
  //     }
  //   },
  //   onParamsChange: async ({ rootStore }) => {
  //     rootStore.routerStore.triggerEnterSideEffects();
  //   },
  // },
];

export default permissionsRoute;
